import { Stack, Typography } from "@mui/material";

const columns = [
  { field: "siteUuid", headerName: "شناسه", flex: 2 },
  { field: "siteName", headerName: "عنوان کسب‌وکار", flex: 2 },
  { field: "chain", headerName: "حلقه", flex: 1 },
  { field: "startDate", headerName: "شروع عضویت", flex: 1 },
  { field: "endDate", headerName: "پایان عضویت", flex: 1 },
];

function SiteTable({ dataTable }) {
  return (
    <Stack width={900} borderRadius={2} gap={1}>
      {/* Header */}
      <Stack direction="row" bgcolor="#c6eff8" borderRadius="12px" overflow="hidden">
        {columns.map((col) => (
          <Stack
            key={col.field}
            flex={col.flex}
            p={1.5}
            alignItems="center"
            justifyContent="center"
          >
            <Typography fontWeight="bold" fontSize="1.2rem">
              {col.headerName}
            </Typography>
          </Stack>
        ))}
      </Stack>

      {/* Rows */}
      {dataTable.map((row) => (
        <Stack key={row.id} direction="row" border="1px solid #E0E0E0" borderRadius={1} overflow="hidden">
          {columns.map((col) => (
            <Stack key={col.field} flex={col.flex} p={1.5} alignItems="center" justifyContent="center">
              <Typography fontSize="1.1rem" textAlign={"center"}>{row[col.field]}</Typography>
            </Stack>
          ))}
        </Stack>
      ))}
    </Stack>
  );
}
export default SiteTable;
